<template>
  <Modal
    :value="showXiangqing"
    title="编辑信息"
    :mask-closable="false"
    width="600"
    @on-ok="changeXiangqing"
    @on-cancel="closeXiangqing"
  >
    <Input v-model="zoneName" size="large" placeholder="请输入社区名称" style="margin-bottom: 10px" />
    <Input v-model="areaRange" size="large" placeholder="请输入所属区域" style="margin-bottom: 10px" />

    <div
      class="address"
      :class="{ address_nodata: !map.zuobiao.label }"
      @click="map.showMap = true"
    >
      {{ map.zuobiao.label || map.placeholder }}
      <i class="iconfont icon-dingweiweizhi"></i>
    </div>
    <map-modal
      v-if="map.showMap"
      :zuobiao="map.zuobiao"
      @confirm="getAddress($event)"
      @cancel="map.showMap = false"
    ></map-modal>

    <Input
      v-model="xiangqing"
      size="large"
      placeholder="请输入详情信息"
      type="textarea"
      :rows="6"
      :maxlength="1000"
    />
    <div class="bianji-pic">
      <upload-img
        :imgArr="copyImgArr"
        :imgWidth="100"
        :imgHeight="62.5"
        @saveImg="saveImg"
        @delPic="delPic"
        :imgNumber="imgNumber"
        :fixedNumber="fixedNum"
      >
        <div class="iconfont icon-shangchuan1 img_add"></div>
      </upload-img>
    </div>
  </Modal>
</template>

<script>
import uploadImg from "@/components/uploadImg";
import mapModal from "@/components/mapModal";
export default {
  components: {
    uploadImg,
    mapModal,
  },
  props: {
    showXiangqing: {
      //控制是否显示搜索弹窗
      type: Boolean,
      default: false,
    },
    picArr: {
      type: Array,
      default: [],
    },
    shequInfo: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    region: {
      type: String,
      default: "",
    },
    address: {
      type: String,
      default: "",
    },
    coordinate: {
      type: String,
      default: ""
    },
    zoneType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      xiangqing: this.shequInfo, //详情编辑弹窗中  详情input
      imgNumber: 4, // 图片上传的最大数
      copyImgArr: [], // 图片列表
      fixedNum: [8, 5],
      zoneName: "",
      areaRange: "",
      map: {
        label: "地址",
        placeholder: "请选择微社区地址",
        showMap: false,
        zuobiao: {
          value: "",
          label: ""
        },
        value: {
          address: "",
          coordinate: ""
        },
      }
    };
  },
  watch: {
    picArr(newValue, oldValue) {
      this.copyImgArr = JSON.parse(JSON.stringify(newValue));
    },
    shequInfo(newValue, oldValue) {
      this.xiangqing = newValue;
    },
    name(newValue, oldValue) {
      this.zoneName = newValue;
    },
    region(newValue, oldValue) {
      this.areaRange = newValue;
    },
    address(newValue, oldValue) {
      this.map.zuobiao.label = newValue;
    },
    coordinate(newValue, oldValue) {
      let obj = JSON.parse(newValue);
      let coordinate = obj.x + ',' + obj.y
      this.map.zuobiao.value = coordinate;
    }
  },
  methods: {
    changeXiangqing() {
      var that = this;
      //正则表情
      var reg = /\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g;
      if (that.zoneName.match(reg) != null) {
        this.$Message.warning("禁止输入表情");
        this.$emit("closexiangqing");
        return;
      }
      var url = this.urlobj.getOrg();
      var picIdList = [];
      this.copyImgArr.forEach((item) => {
        picIdList.push(item.id);
      });
      console.log(this.map);
      this.$post(url, {
        id: sessionStorage.zoneId,
        zoneType: this.zoneType,
        zoneName: that.zoneName,
        remark: that.xiangqing,
        areaRange: that.areaRange,
        picIdList,
        address: that.map.value.address,
        coordinate: that.map.value.coordinate
      }).then((res) => {
        if (res.isSucceed) {
          that.$Message.success("修改成功");
          that.$emit("changsuccess", {
            name: that.zoneName,
            remark: that.xiangqing,
            img: that.copyImgArr,
            areaRange: that.areaRange,
            address: that.map.value.address,
            coordinate: that.map.value.coordinate
          });
        }
      });
    },
    getAddress(val) {
      this.map.zuobiao = val;
      this.map.showMap = false;

      // 更新value
      let [x, y] = val.value.split(",");
      this.map.value = {
        address: val.label,
        coordinate: JSON.stringify({ x, y }),
      };
      console.log(this.map.value);
    },
    closeXiangqing() {
      this.$emit("closexiangqing");
    },
    // 保存 fileObj {id:'',path:''}
    //uploadimg组件的保存方法
    saveImg(fileObj) {
      this.copyImgArr.push(fileObj);
    },
    // 删除图片 communityEntity {id:Number,index:Number}
    delPic(communityEntity) {
      this.copyImgArr.splice(communityEntity.index, 1);
    },
  },
};
</script>
<style lang="less" scoped>
.bianji-pic {
  margin: 30px 0 60px;
}
.img_add {
  color: #bbbbbb;
  border: 1px solid #bbb;
  text-align: center;
  line-height: 42.5px;
  height: 62.5px;
  width: 100px;
  position: relative;
  padding-top: 10px;
}
.form-value {
  color: #999;
  // 与iview一致 垂直居中
  line-height: 0.16rem;
  padding: 10px 0;
}
/*选择地点的样式*/
.address {
  width: 100%;
  height: 32px;
  line-height: 24px;
  padding: 4px 7px;
  font-size: 12px;
  border: 1px solid #dcdee2;
  border-radius: 4px;
  color: #515a6e;
  background-color: #fff;
  background-image: none;
  position: relative;
  cursor: text;
  margin-bottom: 10px;
  .icon-dingweiweizhi {
    float: right;
  }
}
.address_nodata {
  color: #bbb;
}
.address:hover {
  border: 1px solid #ff7b44;
}
.address:active {
  border: 1px solid #ff7b44;
}
</style>

